import React from 'react';
import clsx from 'clsx';
import { useCard } from './CardContext.js';
const Title = ({ children, size }) => {
    return (React.createElement("h3", { className: clsx('text-content', size === 'sm' && 'text-lg leading-6 font-medium') }, children));
};
const Description = ({ children, className }) => {
    return (React.createElement("div", { className: clsx('text-content-subdued', className) },
        React.createElement("p", null, children)));
};
export const CardHeader = props => {
    const { title, description, action, withBorder = false, size = 'md', children, } = props;
    const { padding } = useCard();
    let content;
    if (!!title && !!description && !!action) {
        content = (React.createElement("div", { className: "-ms-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap" },
            React.createElement("div", { className: "ms-4 mt-4" },
                React.createElement(Title, { size: size }, title),
                React.createElement(Description, { className: "mt-1" }, description)),
            React.createElement("div", { className: "ms-4 mt-4 flex-shrink-0" }, action)));
    }
    else if (action) {
        content = (React.createElement("div", { className: "-ms-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap" },
            React.createElement("div", { className: "ms-4 mt-2" },
                React.createElement(Title, { size: size }, title)),
            React.createElement("div", { className: "ms-4 mt-2 flex-shrink-0" }, action)));
    }
    else if (description) {
        content = (React.createElement("div", null,
            React.createElement(Title, { size: size }, title),
            React.createElement(Description, { className: "mt-1" }, description)));
    }
    else if (title) {
        content = React.createElement(Title, { size: size }, title);
    }
    else {
        content = children;
    }
    return (React.createElement("div", { className: clsx(padding === 'md' && 'px-4 py-5 sm:p-6 ', padding === 'sm' && 'px-4 py-5 sm:px-3', !withBorder && 'pb-0 sm:pb-0', withBorder && 'border-b border-line-subdued') }, content));
};
//# sourceMappingURL=CardHeader.js.map